import { useNavigate } from 'react-router-dom';
import {
  Space, Button, Table, Modal, Image,
} from 'antd';
import { useEffect, useState } from 'react';
import { deleteBenefit, getBenefits } from '../../services/benefitServices';
import useTranslation from '../../../hooks/translation/useTranslation';

function AdminBenefits() {
  const { trans } = useTranslation();
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const res = await getBenefits();
    if (res.status === 'success') {
      res.data = res.data.map((data) => ({ ...data, key: data.id }));
      setDataSource(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    setLoading(true);
    const res = await deleteBenefit(id);
    if (res.status === 'success') {
      fetchData();
    }
  };

  const onDelete = (id) => {
    Modal.confirm({
      title: 'ნამდვილად გსურთ წაშლა?',
      onOk: () => {
        handleDelete(id);
      },
      okText: 'დიახ',
      okType: 'danger',
      cancelText: 'არა',
    });
  };

  const columns = [
    {
      title: trans('title'),
      dataIndex: 'title_ka',
      key: 'title_ka',
    },
    {
      title: trans('image'),
      dataIndex: 'image',
      key: 'image',
      render: (record) => <Image src={`/${record}`} />,
    },
    {
      title: trans('edit'),
      key: 'edit',
      render: (record) => (
        <Button onClick={() => navigate(`/admin/benefits/${record.id}/edit`)}>
          {trans('edit')}
        </Button>
      ),
    },
    {
      title: trans('delete'),
      key: 'delete',
      render: (record) => (
        <Button onClick={() => onDelete(record.id)}>
          {trans('delete')}
        </Button>
      ),

    },
  ];

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/benefits/add')}>{trans('add')}</Button>
      <Table loading={loading} pagination={false} columns={columns} dataSource={dataSource} style={{ width: '100%' }} />
    </Space>
  );
}

export default AdminBenefits;
